import React from 'react';
import ComingSoon from '../../components/ComingSoon';

export default function OutwardDashboard() {
    return <ComingSoon moduleName="Outward Operations Dashboard" description="Overview of all outward activities including pending SOs, today's deliveries, orders in allocation, and delivery status summary." estimatedPhase="Phase 4 (Weeks 9-13)" priority="CRITICAL" />;
}
